import {ErrorStateScheduleEnum} from '../../error-state-schedule.enum';

export enum CompanyDocumentsFormErrorStatesEnum {
    UploadFileForRegistrationFailed = ErrorStateScheduleEnum.CompanyDocumentsFormFormStatesStartIndex,
    DocumentRegistrationFailed,
    UploadFileForUpdateFailed,
    UpdateDocumentFailed
}
